import { shallow } from 'zustand/shallow';

import { selectedHomeyStore } from './SelectedHomeyStore';
import {
  selectApiAndScopes,
  selectBaseUrl,
  selectConnectionState,
  selectLanguage,
  selectSelectedHomey,
  selectSelectedHomeyState,
  type SelectedHomeyApiSelection,
  type SelectedHomeyConnectionSelection,
  type SelectedHomeyStateSelection as SelectedHomeyStateSlice,
} from './SelectedHomeyStore.selectors';

export type SelectedHomeyStateSelection = SelectedHomeyStateSlice & {
  retry: () => void;
};

export { type SelectedHomeyApiSelection, type SelectedHomeyConnectionSelection };

export function useSelectedHomeyState(): SelectedHomeyStateSelection {
  const selectedHomeyState = selectedHomeyStore.store(selectSelectedHomeyState, shallow);

  return {
    ...selectedHomeyState,
    retry: retrySelectedHomey,
  };
}

export function useSelectedHomeyConnection(): SelectedHomeyConnectionSelection {
  return selectedHomeyStore.store(selectConnectionState, shallow);
}

export function useApi(): SelectedHomeyApiSelection {
  return selectedHomeyStore.store(selectApiAndScopes);
}

export function useBaseUrl(): { baseUrl: string | undefined } {
  return { baseUrl: selectedHomeyStore.store(selectBaseUrl) ?? undefined };
}

export function useSelectedHomey() {
  return selectedHomeyStore.store(selectSelectedHomey);
}

export function useSelectedHomeyLanguage(): string | null {
  return selectedHomeyStore.store(selectLanguage, shallow);
}

function retrySelectedHomey() {
  selectedHomeyStore.retry();
}
